import type { AuthSessionResponse } from '@solar/contracts';

/**
 * The refresh exchange currently in flight, if any.
 *
 * Bootstrap, React StrictMode double-mounting, and parallel 401 retries must
 * share one rotation. Presenting the same spent refresh token twice triggers
 * the server's reuse detection and revokes the entire session family.
 */
let pendingRefresh: Promise<AuthSessionResponse> | null = null;

/** Runs one refresh at a time and returns the same result to every waiter. */
export function singleFlightRefresh(
  execute: () => Promise<AuthSessionResponse>,
): Promise<AuthSessionResponse> {
  pendingRefresh ??= execute().finally(() => {
    pendingRefresh = null;
  });

  return pendingRefresh;
}

/** Clears in-flight state between tests. */
export function resetRefreshCoordinatorForTests(): void {
  pendingRefresh = null;
}
